// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import intvobjEntity from './entities/intvobj.json';
import intvobjMenu from '../pages/intvobj/menu.json';
import intvobjFullForm from '../pages/intvobj/forms/full.json';
import intvobjContextForm from '../pages/intvobj/forms/context.json';
import intvobjMiniForm from '../pages/intvobj/forms/mini.json';
import intvobjLookupForm from '../pages/intvobj/forms/lookup.json';
import intvobjTableView from '../pages/intvobj/views/table.json';
import intvobjStagesView from '../pages/intvobj/views/stages.json';
import intvobjCardsView from '../pages/intvobj/views/cards.json';
import intvobjInlineView from '../pages/intvobj/views/inline.json';
import intvobjBacklogView from '../pages/intvobj/views/backlog.json';
import intvobjSplitView from '../pages/intvobj/views/split.json';
import intvobjCalendarView from '../pages/intvobj/views/calendar.json';
import intvobjDashboardView from '../pages/intvobj/views/dashboard.json';

/** Тип запису «Заперечення» зі сторінками пакета: меню, форми та подання з pages/intvobj/. */
export const intvobjDefinition: IRecordTypeDefinition = {
  ...intvobjEntity,
  views: assembleViewSet({
      table: intvobjTableView,
      stages: intvobjStagesView,
      cards: intvobjCardsView,
      inline: intvobjInlineView,
      backlog: intvobjBacklogView,
      split: intvobjSplitView,
      calendar: intvobjCalendarView,
      dashboard: intvobjDashboardView,
  }),
  form: intvobjFullForm,
  forms: { full: intvobjFullForm, context: intvobjContextForm, mini: intvobjMiniForm, lookup: intvobjLookupForm },
  menu: intvobjMenu,
} as IRecordTypeDefinition;
